import { collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/Header';
import { db } from '../../utitilties/firebase';
import HomeItem from '../home/components/HomeItem';

const Therapists = () => {

    const [therapists, setTherapists] = useState([])

    const { center } = (useLocation()).state


    const getTherapists = async (user) => {
        const q = query(collection(db, "PhysioTherapists"), where("centerId", "==", center.id));

        const querySnapshot = await getDocs(q);
        let tempThpts = []
        querySnapshot.forEach((doc) => {
            tempThpts.push({ id: doc.id, ...doc.data(), })
        })



        tempThpts.sort((a, b) => a.invitationCode - b.invitationCode)

        let clients = await getClients()

        tempThpts.forEach((t) => {
            t.clients = []
            clients.forEach((cl) => {
                if (cl.invitationCode == t.invitationCode) {
                    center.clients = center.clients + 1
                    t.clients.push(cl)
                }
            })
        })


        setTherapists(tempThpts)

    }
    const getClients = async () => {
        const q = query(collection(db, "Users"));

        const querySnapshot = await getDocs(q);

        let list = []
        querySnapshot.forEach((doc) => {
            list.push({ id: doc.id, ...doc.data() })


        });


        return list
    }

    const deleteHandler = async (id) => {
        let confirm = window.confirm('Are you sure want to delete?')
        if (confirm) {
            await deleteDoc(doc(db, "PhysioTherapists", id))


        }
    }

    useEffect(() => {
        if (center?.id) {
            getTherapists()
        }

    }, [center?.id]
    )

    return (
        <div
            style={{
                padding: 50,
                width: "100%",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
            }}
        >
            <div>
                <Header label={'Therapists'} />
                <div
                    className='home_item'
                    style={{ marginTop: 20, backgroundColor: 'gray', color: 'white' }}
                >
                    <p style={{ width: 250 }} >{'Therapist Name'}</p>
                    <p style={{ width: 250 }} >Email</p>
                    <p  >Code</p>
                    <p style={{ width: 80, textAlign: 'center' }}>{'Clients'}</p>

                </div>
                {
                    therapists.map((tp) => <HomeItem
                        modal
                        deleteHandler={deleteHandler}
                        center={tp}
                        from='THERAPISTS'
                    />)
                }
            </div>
        </div>
    )
}

export default Therapists